/*eslint-disable*/
import images from 'assets/images/images'
import Button from 'components/form-elements/buttons/Button'
import Input from 'components/form-elements/input/Input'
import { useDispatch, useSelector } from 'react-redux'
import { stages } from 'utils/Constants'
import { setRegisterMail } from 'redux/register/registerSlice'
import useToast from 'hooks/useToast'
import { useRequest } from 'hooks/useRequest'
import { Helmet } from "react-helmet";
import LoaderTwo from 'pages/LoaderTwo'
import useTranslate from 'hooks/useTranslate'
import useScript from 'utils/ScriptConvert'
import {useEffect} from 'react'

const StageMail = ({ setRegisterState }) => {
  const dispatch = useDispatch()
  const { showToast } = useToast()
  const [request, loading] = useRequest()
  const { register } = useSelector((state) => state)
  const {t} = useTranslate()
  const isLogin = location.pathname == '/uye-girisi'

	const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA

	useEffect(() => {
		useScript(`https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`)
	}, [])
  const skipStage2 = () => {
    if (register?.registerDataMail && !isLogin) {
      setRegisterState(stages.STAGE_REGISTER)
    } else if (isLogin) {
      setRegisterState(stages.STAGE_NEWLOGIN)
    }
  }


  function isEmail(emailAdress){
    let regex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

  if (emailAdress.match(regex)) 
    return true; 

   else 
    return false; 
}

  const handleCheck = async() => {
    if (register?.registerDataMail == "") {
      return showToast(t('enterEmailAddress'), 'error')
    }else if(!isEmail(register?.registerDataMail))
      return showToast(t('wrongEmailFormat'), 'error')
    {
      !isLogin ?
      await window.grecaptcha.ready(function () {
				window.grecaptcha.execute(recaptchaSiteKey, { action: 'submit' }).then(function (token) {
        request('/InternalAuth/CheckEmail', {
          method: 'POST',
          data: {
            email: register?.registerDataMail,
            token:token
          },

        }).then((res) => {
          if (res?.data?.result) {
            showToast(t('allreadyHasEmail'), 'error')
          } else if (!res?.response?.data) {
            skipStage2()
          }
        })
      })
    })
        : skipStage2()
    }
  }

  const handleChange = (e) => {
    dispatch(setRegisterMail(e.target.value))
  }

  const loginwithGoogle = () => {
    request('/ExternalAuth/Google', {
      method: 'GET'
    }).then((res) => {
      window.location.href = (res?.data?.result)
    })
  };


  const loginwithFacebook = () => {
    request('/ExternalAuth/Facebook', {
      method: 'GET'
    }).then((res) => {
      window.location.href = (res?.data?.result)
    })
  };

  return (
    <div className="register-container">
      <LoaderTwo isDataLoading={loading} />
      <Helmet>
        <meta charSet="utf-8" />
        <title>{isLogin ? t('memberLogin') : t('register')}</title>
				<meta name='description' content={ isLogin ? t('memberLoginMetaDesc') : t('registerMetaDesc') } />
      </Helmet>
      <h1 className='header-m2 mb-3'>{isLogin ? t('memberLogin') : t('register')}</h1>
      <Input containerClassName={""}
        className={''}
        placeholder={t('labelMail')}
        type={'email'}
        textLabel={t('labelMail')}
        name='email'
        required
        value={register?.registerDataMail}
        onChange={handleChange}
      />
      <Button onClick={handleCheck} text={t('continue')} className={"claretredRoundedBtn"} />
      <div className='register-container-infoText'>
        {t('youCanUseSocialMedia')}
      </div>
      <Button onClick={loginwithGoogle} className={"socialMediaBtn"} icon={images.google} text={t('signUpWith',{with:'Google'})} />
      <Button onClick={loginwithFacebook} className={"socialMediaBtn"} icon={images.facebook2} text={t('signUpWith',{with:'Facebook'})} />
      <div className='register-container-footerText'>
        <div>This site is protected by <span>reCAPTCHA</span> and the Google</div>
        <div><span>Privacy Policy</span> and <span>Terms of Service</span> apply.</div>
      </div>
    </div>
  )
}

export default StageMail